/* Original AJAX cart client and small installed-theme adapter. No Storefront API is required.
   Change refresh() for a different drawer. All requests use the buyer's locale root. */
(function () {
  if (window.SBCart) return;
  const root = () => window.Shopify?.routes?.root || '/';
  async function request(endpoint, body) {
    const r = await fetch(root() + endpoint, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin',
      headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await r.json();
    if (!r.ok) throw new Error(data.description || data.message || 'Could not update your cart.');
    return data;
  }
  async function refresh() {
    try {
      const drawer = document.querySelector('#cart-drawer');
      if (!drawer) throw new Error('No supported drawer');
      const icon = document.querySelector('cart-icon');
      const header = icon?.closest('[id^="shopify-section-"]');
      const drawerSection = drawer.closest('[id^="shopify-section-"]');
      const sid = drawerSection?.id.replace('shopify-section-', '') || 'cart-drawer-section';
      const ids = [sid, header?.id.replace('shopify-section-', '')].filter(Boolean);
      const url = new URL(location.href);
      url.searchParams.set('sections', [...new Set(ids)].join(','));
      // no Accept: application/json here: on a product URL Shopify answers with the product's JSON instead of the sections
      const r = await fetch(url, { cache: 'no-store' });
      if (!r.ok) throw new Error('Drawer render failed');
      const sections = await r.json();
      const doc = new DOMParser().parseFromString(Object.values(sections).filter(Boolean).join('\n'), 'text/html');
      const current = drawer.querySelector('cart-drawer-component');
      const next = doc.querySelector('cart-drawer-component');
      if (!current || !next || typeof drawer.open !== 'function') throw new Error('Unsupported drawer version');
      current.replaceWith(next);
      const newIcon = doc.querySelector('cart-icon');
      if (icon && !newIcon) throw new Error('Cart badge render failed');
      if (icon && newIcon) {
        try { sessionStorage.removeItem('cart-count'); } catch { /* storage may be disabled */ }
        icon.replaceWith(newIcon);
      }
      drawer.open();
      document.dispatchEvent(new CustomEvent('sb:cart-updated'));
      return true;
    } catch (err) {
      // Cart mutation already succeeded. Never repeat it when rendering fails.
      location.reload();
      return false;
    }
  }
  let busy = false;
  async function mutate(fn) {
    if (busy) throw new Error('Your cart is updating. Please try again.');
    busy = true;
    try { await fn(); await refresh(); } finally { busy = false; }
  }
  window.SBCart = {
    request, refresh,
    add: (items) => mutate(() => request('cart/add.js', { items })),
    update: (lines) => mutate(async () => {
      const updates = {};
      for (const line of lines) {
        if (line.id) {
          if (String(line.id).startsWith('gid://')) throw new Error('Expected AJAX cart line keys.');
          updates[line.id] = line.quantity;
        }
      }
      if (Object.keys(updates).length) await request('cart/update.js', { updates });
      const items = lines.filter((l) => l.merchandiseId && l.quantity > 0).map((l) => ({ id: Number(String(l.merchandiseId).split('/').pop()), quantity: l.quantity }));
      if (items.length) await request('cart/add.js', { items });
    })
  };
  // Close the installed mobile menu on local anchor navigation. No native JS patch needed.
  document.addEventListener('click', (e) => {
    const link = e.target.closest?.('header-drawer a[href]');
    if (!link || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash) link.closest('header-drawer').close?.();
  });
})();
